import { Box, HStack, Center } from "@chakra-ui/react";
import Avatar from "components/Avatar";
import BoldSpinner from "components/BoldSpinner";
import V2Image from "components/V2Image";
import useAssets from "hooks/useAssets";
import useV2 from "hooks/useV2";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import V2Select from "components/V2Select";
import useV2s from "hooks/useV2s";

type V2SelectorContainerProps = {
  basePath: string;
};

const V2SelectorContainer = ({ basePath }: V2SelectorContainerProps) => {
  const { v2sInWallet } = useAssets();
  const { tokenId, isLoading } = useV2();
  const { allV2Ids } = useV2s();

  const navigate = useNavigate();

  const handleChange = useCallback(
    (tokenId?: number) => {
      if (tokenId) {
        navigate(`${basePath}/${tokenId}`);
      }
    },
    [basePath, navigate]
  );

  return tokenId !== undefined ? (
    <HStack spacing="3">
      <Avatar size="10" position="relative">
        <V2Image
          tokenId={tokenId}
          objectFit="cover"
          opacity={isLoading ? 0.5 : 1}
          transition="all 0.15s"
        />

        {isLoading && (
          <Center
            position="absolute"
            w="full"
            h="full"
            zIndex="1"
            top="0"
            left="0"
          >
            <BoldSpinner size="md" thickness="3px" />
          </Center>
        )}
      </Avatar>

      <Box w="10rem">
        <V2Select
          tokenId={tokenId}
          ownedTokens={v2sInWallet}
          allTokens={allV2Ids}
          onChange={handleChange}
          chakraStyles={{
            control: (provided) => ({
              ...provided,
              fontWeight: "bold",
              border: "none",
              borderBottomRadius: "none",
              fontSize: "2xl",
              p: "0",
              lineHeight: "1",
              borderBottom: "2px solid",
              ":hover": {
                borderBottomColor: "primary.500",
              },
            }),
            valueContainer: (provided) => ({
              ...provided,
              p: "0",
            }),
            dropdownIndicator: (provided) => ({
              ...provided,
              px: "0",
              bg: "transparent",
            }),
            downChevron: (provided) => ({
              ...provided,
              width: "9",
              height: "auto",
            }),
          }}
        />
      </Box>
    </HStack>
  ) : null;
};

export default V2SelectorContainer;
